import EventBus from '../wirebox/event-bus'
import '../wirebox/utilities/xhr-error-message'
import jQuery from 'jquery'
import './error-modal'

EventBus.subscribe('modal.xhr', ({xhr, title = 'Error'} = {}) => {
    EventBus.publish('xhr-error-message', {
        xhr: xhr,
        callback: (messages) => {
            
            //Compile message
            var html = ''
            jQuery.each(messages, (i, message) => {
                html += `<p>${message}</p>`
            })
            
            //Display modal
            EventBus.publish('modal.error', {
                html: html,
                title: title
            })
            
        }
    })
})